import axios from "axios";

export default {
    getTaskContacts: async (companyId, clientId, projectId, isProjectWorkflowTemplate) => {
        const { data } = await axios.get('/email_automation/contacts/', {
            params: {
                company_id: companyId,
                client_id: clientId,
                project_id: projectId,
                is_project_workflow_template: isProjectWorkflowTemplate
            }
        })

        return data
    },
    getTaskFromContacts: async (companyId, clientId) => {
        const { data } = await axios.get('/email_automation/from_contacts/', {
            params: {
                company_id: companyId,
                client_id: clientId
            }
        })

        return data
    }
}